import { Skeleton } from '@/components/ui/skeleton'

export function ChatPageSkeleton() {
  return (
    <div className="flex flex-col flex-1 w-full">
      <div className="flex flex-col w-full h-full p-6 bg-white rounded-lg relative">
        <div className="bg-background flex-1">
          {/* Content Section Skeleton */}
          <div className="flex flex-col justify-between h-full">
            <div>
              <Skeleton className="h-6 w-1/2 my-3 p-4" />
              <div className="space-y-3">
                {Array.from({ length: 8 }).map((_, index) => (
                  <Skeleton key={index} className="h-4 w-full" />
                ))}
              </div>
            </div>

            <div className="flex">
              <Skeleton className="h-8 w-full" />
              <Skeleton className="size-8 ml-3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
